import {useQuery} from "@apollo/client";
import {
    SorterListingResponse,
    GET_SORTER_LISTING,
    SorterType,
} from "../graphql/queries/getSorterListing";
import {useEffect, useState} from "react";

export interface SorterFiltersType {
    sorterCode?: string;
    sorterName?: string;
    sorterStatus?: number;
    sorterType?: number;
    warehouseId?: number;
    warehouseIds?: number[];
}

export interface SorterQueryResult {
    sorterData: SorterType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useSorterQuery = (
    filters: SorterFiltersType,
    currentPage: number,
    pageSize: number,
    skip: boolean = false
): SorterQueryResult => {
    const [sorterData, setSorterData] = useState<SorterType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const queryFilters = {
            ...filters,
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询，当skip为true时跳过查询
    const { data, loading: queryLoading, refetch } = useQuery<SorterListingResponse>(GET_SORTER_LISTING,
        {
            variables: buildQueryVariables(),
            skip: skip
        });

    // 当数据变化时更新状态
    useEffect(() => {
        if (data?.getSorterListing) {
            const responseData = data.getSorterListing.content || [];
            setSorterData(responseData);
            setLoading(false);

            // GraphQL Long 类型会被序列化为字符串，需要转换
            const totalElements = parseInt(data.getSorterListing.totalElements.toString()) || 0;
            setTotal(totalElements);
        }
    }, [data]);

    return {
        sorterData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};

